document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.wp-block-o-partners-grid').forEach(section => {
      const cards = [...section.querySelectorAll('.partner-item')];
      const buttons = [...section.querySelectorAll('[data-type-filter]')];
      const msg = section.querySelector('#partners-list-msg');
  
      if (!cards.length || !buttons.length) return;
  
      const normalize = v => (v || '').toLowerCase();
  
      const applyFilter = type => {
        let visible = 0;
  
        cards.forEach(card => {
          const match =
            type === 'all' ||
            normalize(card.dataset.partnerType) === type;
  
          card.style.display = match ? '' : 'none';
          if (match) visible++;
        });
  
        buttons.forEach(btn =>
          btn.classList.toggle(
            'active',
            normalize(btn.dataset.typeFilter) === type
          )
        );
  
        if (msg) {
          msg.textContent = visible
            ? `${visible} partner${visible > 1 ? 's' : ''} displayed`
            : 'No partners found';
        }
      };
  
      buttons.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();
          applyFilter(normalize(btn.dataset.typeFilter));
        });
      });
  
      applyFilter('all');
    });
  });
  